import { Component, EventEmitter, Output } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SelectKkmTariffState } from '../select-kkm-tariff.state';
import { TariffsModule } from '../../../tariffs/tariffs.module';
import { UniqueTariffsPipe } from '../../shared/pipes/unique-tariffs.pipe';
import { Tariff } from '../../../tariffs/tariff.model';

@Component({
  selector: 'tax-select-kkm-tariffs-list',
  templateUrl: './select-kkm-tariffs-list.component.html',
  styleUrls: ['./select-kkm-tariffs-list.component.sass'],
  standalone: true,
  imports: [
    AsyncPipe,
    TranslateModule,
    TariffsModule,
    NgIf,
    UniqueTariffsPipe,
  ],
})

export class SelectKkmTariffsListComponent {
  @Output() changeTariff = new EventEmitter<Tariff>();
  readonly activeTariff$ = this.selectKkmTariffState.getActiveTariff();
  readonly availableTariffs$ = this.selectKkmTariffState.getAvailableTariff();

  constructor(private selectKkmTariffState: SelectKkmTariffState) {}

  selectTariff(tariff: Tariff): void {
    this.changeTariff.emit(tariff);
  }
}
